// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorPicker_container__3Wicj","selectedColor":"ColorPicker_selectedColor__3upxk"};